import { cn } from '@app/utils/cn';
import { IconComponent } from '@typings';
import { Link, To } from 'react-router-dom';

import { Tooltip } from '../Tooltip';

interface Props {
  icon: IconComponent;
  link: To;
  title: string;
  subtitle: string;
  isActive?: boolean;
  isExpanded?: boolean;
}

export const SidebarNavigationItem = ({ icon: Icon, title, subtitle, link, isActive = false, isExpanded }: Props) => {
  const content = (
    <div className="relative">
      <Link
        to={link}
        className={cn(
          'relative grid min-h-14 grid-cols-[auto,1fr] items-center gap-4 rounded-regular px-[10px] py-0.5 absolute-cursor-pointer hover:bg-neutral-96 focus-visible:focus-outline',
          {
            'bg-neutral-96': isActive,
            'h-14 overflow-hidden': !isExpanded,
          },
        )}
      >
        <Icon className={cn('h-5 w-5 shrink-0 text-neutral-40', { 'mt-4 self-start': !isExpanded, 'text-neutral-20': isActive })} />
        <div className={cn('w-[13.25rem] transition-opacity', { 'opacity-0': !isExpanded })}>
          <span className={cn('text-neutral-40 body-1', { 'text-neutral-20': isActive })}>{title}</span>
          <p className="text-neutral-40 body-5">{subtitle}</p>
        </div>
      </Link>
    </div>
  );

  return isExpanded ? content : (
      <Tooltip content={title} placement="right-center">
        {content}
      </Tooltip>
    );
};
